var operators;

operators = require('./binary-operators');

module.exports = operators({
  add: function(a, b) {
    return a + b;
  },
  subtract: function(a, b) {
    return a - b;
  },
  multiply: function(a, b) {
    return a * b;
  },
  divide: function(a, b) {
    return a / b;
  },
  intDivide: function(a, b) {
    return Math.floor(a / b);
  },
  modulo: function(a, b) {
    return (a % b + b) % b;
  },
  remainder: function(a, b) {
    return a % b;
  }
});

module.exports.negate = function(a) {
  return -a;
};
